import * as constants from './constants';

export function setScreenSize(value) {
  return { type: constants.SET_SCREEN_SIZE, payload: value };
}

export function setIsMobileScreen(value) {
  return { type: constants.SET_IS_MOBILE_SCREEN, payload: value };
}

export function setIsLargeScreen(value) {
  return { type: constants.SET_IS_LARGE_SCREEN, payload: value };
}

export function setIsLogin(value) {
  return { type: constants.SET_IS_LOGIN, payload: value };
}

export function setPageLoginData(value) {
  return { type: constants.SET_PAGE_LOGIN_DATA, payload: value };
}

export function setPageLoginDacData(value) {
  return { type: constants.SET_PAGE_DAC_LOGIN_DATA, payload: value };
}

export function setIsStatus(value) {
  return { type: constants.SET_IS_STATUS, payload: value };
}

export const setVisibleGlobalErrorModal = (value: boolean) => {
  return {
    type: constants.SET_VISIBLE_GLOBAL_ERROR_MODAL,
    payload: value,
  };
};

export function setPopupAdds(value: constants.IPopUpAdds) {
  return { type: constants.SET_POPUP_ADDS, payload: value };
}
